import { axiosInstance as axios } from '../../utils/axiosInstances'
import * as jose from 'jose'
import router from '@/router'
import getProviderId from '@/utils/providerId'

export const initialState = () => {
  return {
    signingIn: false
  }
}

export default {
  state: initialState(),
  getters: {},
  mutations: {
    resetState (state) {
      Object.assign(state, initialState())
    },
    signInCompleted (state) {
      state.signingIn = false
    },
    startSignIn (state) {
      state.signingIn = true
    }
  },
  namespaced: true,
  actions: {
    async signIn (context, data) {
      try {
        console.log(data)
        context.commit('startSignIn')
        const response = await axios.post(`https://cognito-idp.${context.rootState.awsRegionInfo.aws_cognito_region}.amazonaws.com/${context.rootState.awsRegionInfo.aws_cognito_region}_${context.rootState.awsRegionInfo.aws_user_pools_id}/`, data, {
          headers: {
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth'
          }
        })
        console.log(response)
        const idToken = response.data.AuthenticationResult.IdToken
        const decodedToken = jose.decodeJwt(idToken)
        const providerId = getProviderId(decodedToken)
        context.commit('setIdToken', idToken, { root: true })
        context.commit('setProviderId', providerId, { root: true })
        router.push('/')
        context.commit('signInCompleted')
        return response
      } catch (error) {
        console.log(error)
        context.commit('signInCompleted')
        router.push('/')
        if (error.response) {
          return error.response
        }
        return error
      }
    }
  }
}
